import { render, staticRenderFns } from "./product_sort.vue?vue&type=template&id=1560f3be&scoped=true"
import script from "./product_sort.vue?vue&type=script&lang=js"
export * from "./product_sort.vue?vue&type=script&lang=js"
import style0 from "./product_sort.vue?vue&type=style&index=0&id=1560f3be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1560f3be",
  null
  
)

export default component.exports